export const environment = {
  production: false,
  APP_ENDPOINT: 'https://nyc-api.dev.zen.software/api/v1/',
};
